import type { PlainEnvironment } from "@/queries/environment-queries";
import { environmentAdapter } from "@/hooks/log-streaming/adapters";
import { useStreamLogsBase } from "@/hooks/log-streaming/use-stream-logs-base";
import type { UseStreamLogsResult } from "@/hooks/log-streaming/types";

/**
 * Hook for streaming environment logs.
 * Wrapper around the generic base hook with environment-specific adapter.
 */
export function useStreamLogs(options: {
    environment?: PlainEnvironment;
    logsUrl?: string; // Override logs URL (e.g., for service/task logs)
    maxLinesPerGroup?: number;
}): UseStreamLogsResult {
    return useStreamLogsBase({
        resource: options.environment,
        adapter: environmentAdapter,
        maxLinesPerGroup: options.maxLinesPerGroup,
        overrideLogsUrl: options.logsUrl,
    });
}
